import QuestionIdentifier from "../../atoms/QuestionIdentifier/QuestionIdentifier";
import { DividerWrapper } from "./Question.styles";
import { QuestionParametersSection } from "../QuestionParametersSection";
import { QuestionEditorsSection } from "../QuestionEditorsSection";
import React from "react";
import { Grid, IconButton } from "@mui/material";
import { Close } from "@mui/icons-material";

interface QuestionProps {
	prefix?: string;
	isSubquestion?: boolean;
	onRemoveSubquestion?: () => void;
}

export default function Question({ prefix = "", isSubquestion = false, onRemoveSubquestion }: QuestionProps) {
	return (
		<>
			{isSubquestion ? (
				<Grid container item justifyContent={"end"}>
					<IconButton onClick={onRemoveSubquestion}>
						<Close />
					</IconButton>
				</Grid>
			) : null}
			<QuestionIdentifier prefix={prefix} isSubquestion={isSubquestion} />
			<DividerWrapper />
			<QuestionParametersSection prefix={prefix} />
			<DividerWrapper />
			<QuestionEditorsSection prefix={prefix} />
		</>
	);
}
